export const categoryResultsCount = 5;
export const fulltextResultsCount = 5;
